const SESSION_KEY = "sproutly:isMobile";

function readStorage(key) {
  try {
    if (typeof sessionStorage !== "undefined" && sessionStorage.getItem(key) !== null) {
      return sessionStorage.getItem(key);
    }
  } catch {}
  try {
    if (typeof localStorage !== "undefined" && localStorage.getItem(key) !== null) {
      return localStorage.getItem(key);
    }
  } catch {}
  return null;
}

function writeStorage(key, value) {
  try {
    if (typeof sessionStorage !== "undefined") sessionStorage.setItem(key, value);
  } catch {}
  try {
    if (typeof localStorage !== "undefined") localStorage.setItem(key, value);
  } catch {}
}

export function detectIsMobile() {
  if (typeof window === "undefined") return false;
  const cached = readStorage(SESSION_KEY);
  if (cached !== null) return cached === "1";

  let result = false;
  const nav = typeof navigator !== "undefined" ? navigator : null;
  if (nav?.userAgentData && typeof nav.userAgentData.mobile === "boolean") {
    result = nav.userAgentData.mobile;
  } else if (nav?.userAgent) {
    result = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(nav.userAgent);
  }
  if (!result && typeof window.matchMedia === "function") {
    result = window.matchMedia("(pointer: coarse)").matches;
  }

  writeStorage(SESSION_KEY, result ? "1" : "0");
  return result;
}
